var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.08447C0 0.979903 0.895431 0.0844727 2 0.0844727H22C23.1046 0.0844727 24 0.979903 24 2.08447V22.0845C24 23.189 23.1046 24.0845 22 24.0845H2C0.89543 24.0845 0 23.189 0 22.0845V2.08447Z",
    fill: "url(#paint0_linear_1_179)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.9541C0 29.8495 0.895431 28.9541 2 28.9541H22C23.1046 28.9541 24 29.8495 24 30.9541V50.9541C24 52.0587 23.1046 52.9541 22 52.9541H2C0.89543 52.9541 0 52.0587 0 50.9541V30.9541Z",
    fill: "url(#paint1_linear_1_179)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.8237C0 58.7192 0.895431 57.8237 2 57.8237H22C23.1046 57.8237 24 58.7192 24 59.8237V79.8237C24 80.9283 23.1046 81.8237 22 81.8237H2C0.89543 81.8237 0 80.9283 0 79.8237V59.8237Z",
    fill: "url(#paint2_linear_1_179)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8696 2.08447C28.8696 0.979903 29.7651 0.0844727 30.8696 0.0844727H50.8696C51.9742 0.0844727 52.8696 0.979903 52.8696 2.08447V22.0845C52.8696 23.189 51.9742 24.0845 50.8696 24.0845H30.8696C29.7651 24.0845 28.8696 23.189 28.8696 22.0845V2.08447Z",
    fill: "url(#paint3_linear_1_179)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8696 30.9541C28.8696 29.8495 29.7651 28.9541 30.8696 28.9541H50.8696C51.9742 28.9541 52.8696 29.8495 52.8696 30.9541V50.9541C52.8696 52.0587 51.9742 52.9541 50.8696 52.9541H30.8696C29.7651 52.9541 28.8696 52.0587 28.8696 50.9541V30.9541Z",
    fill: "url(#paint4_linear_1_179)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8696 59.8237C28.8696 58.7192 29.7651 57.8237 30.8696 57.8237H50.8696C51.9742 57.8237 52.8696 58.7192 52.8696 59.8237V79.8237C52.8696 80.9283 51.9742 81.8237 50.8696 81.8237H30.8696C29.7651 81.8237 28.8696 80.9283 28.8696 79.8237V59.8237Z",
    fill: "url(#paint5_linear_1_179)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7393 2.08447C57.7393 0.979903 58.6347 0.0844727 59.7393 0.0844727H79.7393C80.8438 0.0844727 81.7393 0.979903 81.7393 2.08447V22.0845C81.7393 23.189 80.8438 24.0845 79.7393 24.0845H59.7393C58.6347 24.0845 57.7393 23.189 57.7393 22.0845V2.08447Z",
    fill: "url(#paint6_linear_1_179)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7393 30.9541C57.7393 29.8495 58.6347 28.9541 59.7393 28.9541H79.7393C80.8438 28.9541 81.7393 29.8495 81.7393 30.9541V50.9541C81.7393 52.0587 80.8438 52.9541 79.7393 52.9541H59.7393C58.6347 52.9541 57.7393 52.0587 57.7393 50.9541V30.9541Z",
    fill: "url(#paint7_linear_1_179)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7393 59.8237C57.7393 58.7192 58.6347 57.8237 59.7393 57.8237H79.7393C80.8438 57.8237 81.7393 58.7192 81.7393 59.8237V79.8237C81.7393 80.9283 80.8438 81.8237 79.7393 81.8237H59.7393C58.6347 81.8237 57.7393 80.9283 57.7393 79.8237V59.8237Z",
    fill: "url(#paint8_linear_1_179)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_179",
    x1: -19.3362,
    y1: 81.8237,
    x2: 180.398,
    y2: 81.8237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42AAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3333FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.58dc25663ea26ce67f15ac1626206ac8.svg";
export { ForwardRef as ReactComponent };